import React from "react";
import { Search, BarChart3, Wrench, FileCheck2 } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: Search,
    title: "Keşif",
    body: "Saha ziyareti, ekipman envanteri ve kritiklik haritası ile ihtiyaç netleştirilir.",
  },
  {
    n: "02",
    icon: BarChart3,
    title: "Ölçüm & Analiz",
    body: "ISO standartlarına uygun titreşim ölçümü, FFT ve hata teşhisi yapılır.",
  },
  {
    n: "03",
    icon: Wrench,
    title: "Uygulama",
    body: "Balans, hizalama, revizyon veya yedek parça uygulaması sahada gerçekleştirilir.",
  },
  {
    n: "04",
    icon: FileCheck2,
    title: "Doğrulama & Rapor",
    body: "Sonuç ölçümleri ile iyileşme doğrulanır, teknik PDF rapor teslim edilir.",
  },
];

export default function Process() {
  return (
    <section
      id="surec"
      data-testid="process-section"
      className="bg-slate-900 text-white relative overflow-hidden bg-blueprint border-y-4 border-cyan-600 py-20 lg:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="divider-tick"></span>
            <span className="overline">SÜREÇ</span>
            <span className="divider-tick"></span>
          </div>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight max-w-3xl mx-auto"
            style={{ fontFamily: "Outfit" }}
          >
            Keşiften raporlamaya — 4 adımlık şeffaf bir akış.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-slate-700/40 border border-slate-700/40">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.n}
                data-testid={`process-step-${i + 1}`}
                className="bg-slate-900 p-8 lg:p-10 group relative hover:bg-slate-800 transition-colors duration-300"
              >
                <div className="flex items-center justify-between mb-6">
                  <span className="font-mono-accent text-5xl font-bold text-cyan-500/40 group-hover:text-cyan-400 transition-colors">
                    {s.n}
                  </span>
                  <div className="w-12 h-12 grid place-items-center bg-cyan-600 rounded-sm">
                    <Icon className="w-6 h-6 text-white" strokeWidth={1.5} />
                  </div>
                </div>
                <h3
                  className="text-xl font-bold mb-3 text-white"
                  style={{ fontFamily: "Outfit" }}
                >
                  {s.title}
                </h3>
                <p className="text-sm text-slate-300 leading-relaxed">{s.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
